import { action } from '@ember/object';
import Component from '@glimmer/component';

import { Aggregation } from 'webapp/enums/enums';

// this can be included block-wide (no dataSelect) or per data-select
import FormRadiobuttonGroupComponent from 'webapp/components/form/radiobutton-group';

import type Block from 'webapp/models-custom/block';
import type BlockSetup from 'webapp/models-custom/block-setup';
import type DataSelect from 'webapp/models-custom/data-select';

interface Args {
	blockM: Block;
	dataSelect?: DataSelect;
}

export default class BlockSettingsMetricAggregationComponent extends Component<Args> {
	options = [
		{
			value: '',
			label: 'Off',
		},
		{
			value: Aggregation.SUM,
			label: 'SUM',
		},
		{
			value: Aggregation.AVG,
			label: 'AVG',
		},
		{
			value: Aggregation.MEDIAN,
			label: 'MED',
		},
		{
			value: Aggregation.MIN,
			label: 'MIN',
		},
		{
			value: Aggregation.MAX,
			label: 'MAX',
		},
	];

	get block(): Block {
		return this.args.blockM;
	}

	get blockSetup(): BlockSetup {
		return this.block.blockSetup;
	}

	get isForSingleDataSelect(): boolean {
		return !!this.args.dataSelect;
	}

	get selected(): Aggregation | '' {
		return this.isForSingleDataSelect
			? this.args.dataSelect?.aggregation || ''
			: this.blockSetup.dataSelectsShown[0]?.aggregation || '';
	}

	@action
	changeSelected(value: AnySimpleValue): void {
		const dataSelectsToUpdate = this.args.dataSelect
			? [this.args.dataSelect]
			: this.blockSetup.dataSelectsShown;

		const aggregation = value as Aggregation | '';
		dataSelectsToUpdate.forEach((ds) => {
			ds.aggregation = aggregation || null;
			this.blockSetup.saveDataSelect(ds);
		});

		// tracking
		const aggregate = (aggregation || 'OFF').toLowerCase();
		this.blockSetup.trackBlockPropertySettingsChangeEvent({ aggregate });
	}
	<template>
		<div class="row">
			<label>Show aggregate</label>
			<FormRadiobuttonGroupComponent
				class="radiobutton-switcher"
				@name="aggregation"
				@selected={{this.selected}}
				@options={{this.options}}
				@onChange={{this.changeSelected}}
				@theme="dark-blue"
			/>
		</div>
	</template>
}
